import { createMutation } from 'QueryKit'
import {
  postImageAnnotation,
  postImageAnnotationGroup,
  deleteImageAnnotation,
  deleteImageAnnotationGroup,
  patchImageAnnotationGroup,
  putImageAnnotationGroup,
  patchImageAnnotation,
  postBatchDeleteImageAnnotation,
  patchAnnotationsAndPostGroup,
  patchAnnotationsAndPatchGroup,
} from 'API/definitions/iris/annotation'

const useCreateImageAnnotationMutation = createMutation({
  mutationKey: 'annotation_create',
  mutationFn: postImageAnnotation,
})

const useDeleteImageAnnotationMutation = createMutation({
  mutationKey: 'annotation_delete',
  mutationFn: (annotationDetailsObj: { annotationUuids: Array<string>; annotationValues; imageUuid: string }) => {
    const { annotationUuids } = annotationDetailsObj
    if (annotationUuids.length > 1) return postBatchDeleteImageAnnotation(annotationUuids)
    else return deleteImageAnnotation(annotationUuids[0])
  },
})

const useUpdateImageAnnotationMutation = createMutation({
  mutationKey: 'annotation_update',
  mutationFn: patchImageAnnotation,
})

const usePostImageAnnotationGroup = createMutation({
  mutationKey: 'annotation_createGroup',
  mutationFn: postImageAnnotationGroup,
})

const usePatchImageAnnotationGroup = createMutation({
  mutationKey: 'annotation_patchGroup',
  mutationFn: patchImageAnnotationGroup,
})

const usePutImageAnnotationGroup = createMutation({
  mutationKey: 'annotation_putGroup',
  mutationFn: putImageAnnotationGroup,
})

const useDeleteAnnotationGroup = createMutation({
  mutationKey: 'annotation_deleteGroup',
  mutationFn: deleteImageAnnotationGroup,
})

const usePatchAnnotationsAndPostGroup = createMutation({
  mutationKey: 'annotation_update_postgroup',
  mutationFn: patchAnnotationsAndPostGroup,
})

const usePatchAnnotationsAndPatchGroup = createMutation({
  mutationKey: 'annotation_update_patchgroup',
  mutationFn: patchAnnotationsAndPatchGroup,
})

export {
  useCreateImageAnnotationMutation,
  useDeleteImageAnnotationMutation,
  useUpdateImageAnnotationMutation,
  usePostImageAnnotationGroup,
  usePatchImageAnnotationGroup,
  usePutImageAnnotationGroup,
  useDeleteAnnotationGroup,
  usePatchAnnotationsAndPostGroup,
  usePatchAnnotationsAndPatchGroup,
}
